import {performHttpRequest} from "@/http/http";

export async function check() {

    let checkToken = ''
    if(location.hash) {
        checkToken = '?t=' + location.hash.slice(1);
        location.hash = ''
    }

    let loginType = ''
    if(window.urlParamsObject.loginType) {
        if(checkToken) {
            loginType = '&'
        } else {
            loginType = '?'
        }
        loginType += 'loginType=1'
    }

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/check' + checkToken + loginType,
        'GET',
        null,
        'application/json',
        true,
        true
    )
}

export async function checkSession() {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/myself/session/bookmark/' + window.websiteID,
        'GET',
        null,
        'application/json',
        true,
        false
    )
}
